import React from 'react';
import { FiArrowLeft } from "react-icons/fi";

const stepOneHalf = ({ otp, handleOtpChange, handleOtpKeyDown, otpRefs, otpError, submitError, handleResend, resendCountdown, resendLoading, setStep, handleOtpSubmit, isLoading }: any) => {
  return (
    <div>
      <label className="zs-label zs-label-required">Enter OTP</label>
      <p className="mb-3 text-xs text-ink-3">We sent a 6-digit code to your email.</p>
      <div className="flex justify-between gap-1.5 sm:gap-2">
        {otp.map((digit, index) => (
          <input
            key={index}
            type="text"
            maxLength={1}
            value={digit}
            onChange={(e) => handleOtpChange(e.target.value, index)}
            onKeyDown={(e) => handleOtpKeyDown(e, index)}
            ref={(el) => (otpRefs.current[index] = el)}
            aria-label={`Digit ${index + 1}`}
            aria-invalid={otpError ? true : undefined}
            className="zs-input h-12 w-full min-w-0 max-w-[52px] px-0 text-center font-display text-lg font-semibold tabular-nums"
          />
        ))}
      </div>
      {otpError && <p className="zs-error text-center">{otpError}</p>}
      {submitError && <p className="zs-error text-center">{submitError}</p>}
      <div className="mt-3 flex justify-end">
        <button
          onClick={handleResend}
          disabled={resendCountdown > 0 || resendLoading}
          className={`text-sm font-medium ${resendCountdown > 0 || resendLoading ? "cursor-not-allowed text-ink-4 tabular-nums" : "zs-link"}`}
          type="button"
        >
          {resendLoading ? "Resending..." : resendCountdown > 0 ? `Resend in ${resendCountdown}s` : "Resend OTP"}
        </button>
      </div>
      <div className="mt-6 flex items-center justify-between gap-3">
        <button onClick={() => setStep(1)} className="zs-btn zs-btn-ghost">
          <FiArrowLeft aria-hidden="true" />
          Back
        </button>
        <button
          onClick={handleOtpSubmit}
          className="zs-btn zs-btn-primary min-w-[120px]"
          disabled={isLoading}
        >
          {isLoading ? "Verifing..." : "Next"}
        </button>
      </div>
    </div>
  );
};

export default stepOneHalf;
